'use strict';

const _ = require('lodash');
const url = require('url');
const qs = require('querystring');
const config = require('./config');

const HOUR = 60 * 60 * 1000;
const PROTOCOL_TEST = /^https?:\/\//i;

function init() {
	if (config.get('AuthServerURL')) {
		let panelURI = url.parse(window.location.href);
		let query = panelURI.query;
		let token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, "$1");
		if (_.isString(query)) {
			query = qs.parse(query);
		}
		if (token) {
			config.set('token', token);
		} else if (query && query.access_token) {
			// Handle redirect from authorisation form.
			token = query.access_token;
			config.set('token', token);
			let expires = new Date(query.expires_in) || new Date(_.now() + HOUR * 6);
			document.cookie = "token=" + token + '; expires=' + expires.toDateString();
			panelURI.search = '';
			panelURI.query = _.omit(query, 'access_token', 'expires_in', 'scope', 'token_type', 'username');
			try {
				window.history.replaceState({token, expires}, '', url.format(panelURI));
			} catch (e) {
				console.error(e);
			}
		} else {
			return auth();
		}
	}
	return true;
}

function auth(redirectURL) {
	let authServerURL = config.get('AuthServerURL');
	let clientID = config.get('ClientID', 'billing_panel');
	let scope = config.get('AuthenticationRole', '');

	if (!authServerURL) {
		return;
	}

	if (_.isString(redirectURL)) {
		redirectURL = url.parse(redirectURL)
	} else if (!redirectURL) {
		redirectURL = url.parse(window.location.href);
	}

	let query = redirectURL.query;
	if (_.isString(query)) {
		query = qs.parse(query);
	}

	// Remove token from cookie
	document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";

	// Cleanup redirect url
	redirectURL.query = _.omit(
		query, 'access_token', 'client_id', 'username',
		'redirect_url', 'token_type', 'expires_in', 'scope');

	// Redirect to Auth server
	// Add protocol if needed, since url.parse doesn't manage
	let authURI = authServerURL;
	if (!PROTOCOL_TEST.test(authURI)) {
		authURI = 'https://' + authURI;
	}
	console.log('Redirecting to authorisation service', url.format(authURI));
	authURI = url.parse(authURI);
	authURI.pathname = 'implicit';
	authURI.query = {
		response_type: 'token', client_id: clientID,
		redirect_url: url.format(redirectURL), scope: scope,
		establish_user_from_credentials: false
	};
	authURI = url.format(authURI);
	// console.debug(authURI);
	window.location.assign(url.format(authURI));
}

function signOut(redirectURI) {
	document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
	let redirectURL;
	if (!redirectURI) {
		let panelURL = url.parse(window.location.href);
		redirectURL = {
			protocol: panelURL.protocol, hostname: panelURL.hostname,
			port: panelURL.port, pathname: panelURL.pathname
		};
	} else {
		redirectURL = url.parse(redirectURI);
	}
	auth(redirectURL);
}

module.exports = auth;
auth.init = init;
auth.auth = auth;
auth.signOut = signOut;